module.exports = __webpack_public_path__ + "media/pages/assets/images/lightbulb-39f1bd4b231e559ef96fe27c38ee05a4.svg";